import React, { useEffect, useState } from "react";
import styles from "./CookieBanner.module.scss";
import classNames from "classnames";

export const CookieBannerComponent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShouldRender(true);
      // Delay showing slightly for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
    setTimeout(() => setShouldRender(false), 500);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
    setTimeout(() => setShouldRender(false), 500);
  };

  if (!shouldRender) return null;

  return (
    <div
      className={classNames(styles["cookieBanner"], {
        [styles["visible"] as string]: isVisible,
      })}>
      <p>
        We use cookies to enhance your experience. By continuing to visit this
        site you agree to our use of cookies.
      </p>
      <div className={styles["buttons"]}>
        <button className={styles["decline"]} onClick={handleDecline}>
          Decline
        </button>
        <button className={styles["accept"]} onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};
